import React, { useState } from 'react';
import { Box, Button, Snackbar, Alert, Typography } from '@mui/material';
import { supabase } from '../bd/supabase';

export default function FormularioBoletin() {
  const [formData, setFormData] = useState({
    nombre: '',
    correo: '',
    conociste: '',
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) validateField(name, value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = '';
    if (!value.trim()) {
      error = 'Este campo es requerido';
    } else if (
      name === 'correo' &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ) {
      error = 'Correo inválido';
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const validarFormulario = () => {
    const nuevosErrores = {};
    if (!formData.nombre.trim()) nuevosErrores.nombre = 'Este campo es requerido';
    if (!formData.correo.trim()) nuevosErrores.correo = 'Este campo es requerido';
    if (!formData.conociste.trim()) nuevosErrores.conociste = 'Este campo es requerido';
    if (
      formData.correo &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.correo)
    ) {
      nuevosErrores.correo = 'Correo inválido';
    }
    setErrors(nuevosErrores);
    return Object.keys(nuevosErrores).length === 0;
  };

  const handleSubmit = async () => {
    if (!validarFormulario()) return;

    try {
      const { error } = await supabase
        .from('boletin')
        .insert([formData]);

      if (error) {
        console.error('Error en Supabase:', error.message);
        return;
      }

      setOpenSnackbar(true);
      setFormData({ nombre: '', correo: '', conociste: '' });
      setErrors({});
      setTouched({});
    } catch (err) {
      console.error('Error inesperado:', err);
    }
  };

  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: '#0D0D0D',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        p: { xs: 3, sm: 4, md: 5 },
        gap: 2,
      }}
    >
      {[
        { label: 'Nombre', name: 'nombre' },
        { label: 'Correo', name: 'correo' },
        { label: '¿Cómo nos conociste?', name: 'conociste' },
      ].map(({ label, name }, index) => (
        <Box key={index}>
          <Box
            component="input"
            name={name}
            placeholder={label}
            value={formData[name]}
            onChange={handleChange}
            onBlur={handleBlur}
            sx={{
              width: '100%',
              height: '48px',
              borderRadius: '25px',
              px: 3,
              background: 'linear-gradient(145deg, rgba(50, 50, 50, 0.2), rgba(0, 0, 0, 0.5))',
              color: '#f1f1f1',
              border: 'none',
              outline: 'none',
              fontSize: '15px',
              letterSpacing: '0.5px',
              boxShadow: `
                inset 0 1px 2px rgba(255, 255, 255, 0.05),
                0 3px 8px rgba(0, 0, 0, 0.3)
              `,
              transition: 'all 0.3s ease-in-out',
              '&::placeholder': {
                color: '#aaa',
                fontWeight: 400,
                opacity: 0.8,
              },
              '&:focus': {
                boxShadow: `
                  inset 0 1px 2px rgba(255, 255, 255, 0.08),
                  0 0 10px rgba(19, 184, 218, 0.5)
                `,
              },
            }}
          />
          {touched[name] && errors[name] && (
            <Typography
              variant="caption"
              sx={{ color: '#EB5757', ml: 2, mt: 0.5, display: 'block' }}
            >
              {errors[name]}
            </Typography>
          )}
        </Box>
      ))}

      <Button
        onClick={handleSubmit}
        sx={{
          alignSelf: { xs: 'center', sm: 'flex-end' },
          background: 'linear-gradient(90deg, #0A6274 0%, #13B8DA 100%)',
          color: 'white',
          borderRadius: '30px',
          px: 4,
          py: 1.2,
          fontWeight: 700,
          fontSize: { xs: '13px', sm: '14px' },
          textTransform: 'none',
          mt: 1,
          '&:hover': {
            opacity: 0.9,
            background: 'linear-gradient(90deg, #0A6274 0%, #13B8DA 100%)',
          },
        }}
      >
        Unirse
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          sx={{ width: '100%' }}
        >
          ¡Gracias por suscribirte!
        </Alert>
      </Snackbar>
    </Box>
  );
}
